import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ContainerIndex from './containers/ContainerIndex';
import ContainerShow from './containers/ContainerShow';
import FieldShow from './fields/FieldShow';
import FieldsetShow from './fieldsets/FieldsetShow';
import FormShowEdit from './forms/FormShowEdit';
import FormShowSubmissions from './forms/FormShowSubmissions';
import MailersIndex from './mailers/MailersIndex';
import MailerShow from './mailers/MailerShow';
import SubmissionShow from './submissions/SubmissionShow';
import { NavWrapper, ExportsWrapper } from './NavWrapper';
import { ErrorRouteCatch } from './common/ErrorPage';
import * as load from '../helpers/routeLoaders';
import PermissionsPage from './roles/PermissionsPage';
import ExportConsumer from './common/ExportConsumer';
import GlobalSearch from './global-search/GlobalSearch';

const App = (props, railsContext) => {
  console.log('root app loaded with:', props);
  console.log('railsContext:', railsContext);
  const router = createBrowserRouter([
    { path: '*', element: <ErrorRouteCatch {...props} /> },
    {
      path: '/manage',
      element: <ExportsWrapper />,
      errorElement: <ErrorRouteCatch {...props} />,
      children: [
        {
          path: 'submissions/export',
          element: <ExportConsumer {...props} />,
        },
        {
          path: 'containers/export_result',
          element: <ExportConsumer {...props} />,
        },
      ],
    },
    {
      path: '/manage',
      element: <NavWrapper current_user={props.current_user} />,
      children: [
        {
          path: '/manage',
          errorElement: <ErrorRouteCatch {...props} />,
          children: [
            {
              path: 'global_search',
              element: <GlobalSearch />,
            },
            {
              path: 'permissions',
              element: <PermissionsPage />,
              loader: load.permissionsLoader,
            },
            {
              path: '',
              element: <ContainerIndex />,
              loader: load.containersLoader,
            },
            {
              path: 'containers/:container_id',
              element: <ContainerShow />,
              loader: load.containerLoader,
            },
            {
              path: 'forms/:form_id',
              element: <FormShowSubmissions />,
              loader: load.formSubmissionsLoader,
            },
            {
              path: 'forms/:form_id/edit',
              element: <FormShowEdit />,
              loader: load.formEditLoader,
            },
            {
              path: 'fieldsets/:fieldset_id',
              element: <FieldsetShow />,
              loader: load.fieldsetLoader,
            },
            {
              path: 'fields/:field_id',
              element: <FieldShow />,
              loader: load.fieldLoader,
            },
            {
              path: 'forms/:form_id/mailers',
              element: <MailersIndex />,
              loader: load.mailersLoader,
            },
            {
              path: 'mailers/:mailer_id',
              element: <MailerShow />,
              loader: load.mailerLoader,
            },
            {
              path: 'submissions/:submission_id',
              element: <SubmissionShow />,
              loader: load.submissionLoader,
            },
          ],
        },
      ],
    },
  ]);

  const useStrictMode = false;
  // StrictMode off by default because it's annoying
  return () =>
    railsContext.railsEnv === 'development' && useStrictMode ? (
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    ) : (
      <RouterProvider router={router} />
    );
};

export default App;
